import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
} from "src/app/shared/service";
import {
    DtgListType
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.manage.car.ext.accept.main.component.html'
    ,styleUrls: ["./dtg.manage.car.ext.accept.main.component.scss"]
    ,providers: []
})
export class DtgManageCarExtAcceptMainComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    DtgListType = DtgListType;

    constructor(
        private fvmsCommonService:FvmsCommonService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
            });
     }

    ngOnInit() {

    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {

    }
}